import { EnvironmentProviders, importProvidersFrom, Provider } from '@angular/core';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { withNgxsFormPlugin } from '@ngxs/form-plugin';
import { RouterStateSerializer, withNgxsRouterPlugin } from '@ngxs/router-plugin';
import { provideStore, withNgxsDevelopmentOptions } from '@ngxs/store';
import { NgxsSelectSnapshotModule } from '@ngxs-labs/select-snapshot';

import { environment } from '@efficiently/client-core-environment';
import { SpinnerState } from '@efficiently/client-core-file-loader';
import { ToastState } from '@efficiently/client-core-toast';
import { AccountState } from '@efficiently/client-domain-accounts';
import { ApplicationSettingsState } from '@efficiently/client-domain-application-settings';
import { ItemConstructionRiskState } from '@efficiently/client-domain-construction-risk';
import { CoreState } from '@efficiently/client-domain-core';
import { ItemFamilyState, ItemState, ItemVerificationState } from '@efficiently/client-domain-item-catalog';
import { PermissionState } from '@efficiently/client-domain-permissions';
import { ProjectDetailState } from '@efficiently/client-domain-project-detail';

import { AppRouterStateSerializer } from '@ds/store/router/router.state';
import { MultiLevelMenuState } from '@ds/store/shared/multi-level-menu/multi-level-menu.state';

export const appStoreProviders: Array<Provider | EnvironmentProviders> = [
	importProvidersFrom(NgxsSelectSnapshotModule.forRoot()),
	provideStore(
		[
			AccountState,
			ItemFamilyState,
			ItemState,
			ProjectDetailState,
			CoreState,
			ToastState,
			SpinnerState,
			PermissionState,
			ApplicationSettingsState,
			MultiLevelMenuState,
			ItemVerificationState,
			ItemConstructionRiskState,
		],
		{
			developmentMode: !environment.production,
		},
		withNgxsReduxDevtoolsPlugin({ disabled: environment.production }),
		withNgxsFormPlugin(),
		withNgxsRouterPlugin(),
		withNgxsDevelopmentOptions({ warnOnUnhandledActions: true }),
	),
	{ provide: RouterStateSerializer, useClass: AppRouterStateSerializer },
];
